const fraudType = {
  APPLICATION_FRAUD: 'APPLICATION_FRAUD',
  MULE_ACCOUNT: 'MULE_ACCOUNT',
  SCAMMER_ACCOUNT: 'SCAMMER_ACCOUNT',
  OTHER: 'OTHER',
  UNKNOWN: 'UNKNOWN'
};

module.exports = fraudType;
